import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { TimeslotCheckAvailabilityResponse } from '../../models/timeslot-check-availability-reponse';

const APIURL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class BasketService {
  private http = inject(HttpClient);

  /**
   * `start`/`end` are bare API datetimes (`YYYY-MM-DDTHH:mm:ss`, Danish local), matching
   * `BasketItem.start`/`.end` and the sibling services. They were typed `Date` while the callers
   * held strings, so the template below interpolated `Date.prototype.toString()` — producing an
   * unencoded `?start=Fri Aug 28 2026 10:00:00 GMT+0200 (Central European Summer Time)` that the
   * server binds as `Kind=Local` rather than the Danish wall-clock it expects.
   */
  checkAvailability(
    resourceId: number,
    start: string,
    end: string,
    userId?: number,
    activityId?: number,
    bookingId?: number,
  ): Observable<TimeslotCheckAvailabilityResponse> {
    let url = `${APIURL}/bookingperiods/check_availability?start=${start}&end=${end}&resource_id=${resourceId}`;
    if (userId) {
      url += `&user_id=${userId}`;
    }
    if (activityId) {
      url += `&activity_id=${activityId}`;
    }
    if (bookingId) {
      url += `&booking_id=${bookingId}`;
    }
    return this.http.get<TimeslotCheckAvailabilityResponse>(url);
  }
}
